import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { useNavigate, useSearchParams } from "react-router-dom";
import Autoplay from "embla-carousel-autoplay";
import { useRef } from "react";
import { useAnalytics } from "@/hooks/useAnalytics";
import { useIsMobile } from "@/hooks/use-mobile";
import { useTranslation } from "react-i18next";

export const Hero = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const plugin = useRef(Autoplay({
    delay: 9000,
    stopOnInteraction: true
  }));
  const {
    trackAction
  } = useAnalytics({
    component: "Hero"
  });
  const [searchParams] = useSearchParams();
  const handleStartFreeTrial = () => {
    // Track the click action
    trackAction("hero_free_trial_click");

    // Get UTM parameters from URL
    const utm_source = searchParams.get("utm_source") || "";
    const utm_medium = searchParams.get("utm_medium") || "";
    const utm_campaign = searchParams.get("utm_campaign") || "";

    // Build the navigation URL with UTM parameters
    const authUrl = new URL("/auth", window.location.origin);
    authUrl.searchParams.append("tab", "signup");

    // Only add UTM parameters if they exist
    if (utm_source) authUrl.searchParams.append("utm_source", utm_source);
    if (utm_medium) authUrl.searchParams.append("utm_medium", utm_medium);
    if (utm_campaign) authUrl.searchParams.append("utm_campaign", utm_campaign);
    navigate(authUrl.pathname + authUrl.search);
  };
  return <div className="relative overflow-hidden bg-gradient-to-b from-pink-50 to-white pt-20 sm:pt-24 md:pt-32 pb-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="text-left lg:w-1/2 max-w-2xl">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight animate-fade-up text-gebeya-purple" style={{
            lineHeight: 1.1
          }}>
              {t('hero.title')}{' '}
              <br />
              {t('hero.subtitle').split('Gebeya Jitume')[0]} <span className="bg-gradient-to-r from-gebeya-pink to-gebeya-orange bg-clip-text text-transparent relative z-10">Gebeya Jitume</span> {t('hero.subtitle').split('Gebeya Jitume')[1]}
            </h1>
            <p className="mt-4 sm:mt-6 text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 animate-fade-up [animation-delay:200ms]">{t('hero.description')}</p>
            <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row gap-4 items-start animate-fade-up [animation-delay:400ms]">
              <Button size="lg" className="bg-gradient-to-r from-gebeya-pink to-gebeya-orange hover:opacity-90 text-white min-w-[200px] w-full sm:w-auto" onClick={handleStartFreeTrial}>
                {t('hero.startFreeTrial')}
              </Button>
            </div>
          </div>
          <div className="lg:w-1/2 animate-fade-up [animation-delay:600ms]">
            <Carousel opts={{
            align: "start",
            loop: true
          }} plugins={[plugin.current]} className="w-full">
              <CarouselContent>
                <CarouselItem>
                  <div className="w-full rounded-2xl shadow-2xl overflow-hidden relative">
                    <img src="/lovable-uploads/aab74936-48c7-4c04-af67-2aa314c1799e.png" alt="Man smiling while working on laptop" className="w-full h-auto" style={{
                    transform: "perspective(1000px) rotateY(-5deg) rotateX(5deg)"
                  }} />
                    <div className="absolute bottom-6 left-6 right-6">
                      <div className="bg-black/70 backdrop-blur-sm rounded-xl p-3 sm:p-4 shadow-lg border border-white/10">
                        <p className="text-white text-sm sm:text-base md:text-lg font-medium">
                          {t('hero.kevinOverlay')}
                        </p>
                      </div>
                    </div>
                  </div>
                </CarouselItem>
                <CarouselItem>
                  <div className="w-full rounded-2xl shadow-2xl overflow-hidden relative">
                    <img src="/lovable-uploads/c863d0a5-e56b-4140-b008-d3d5435aad23.png" alt="Makeup artist with client" className="w-full h-auto" style={{
                    transform: "perspective(1000px) rotateY(-5deg) rotateX(5deg)"
                  }} />
                    <div className="absolute bottom-6 left-6 right-6">
                      <div className="bg-black/70 backdrop-blur-sm rounded-xl p-3 sm:p-4 shadow-lg border border-white/10">
                        <p className="text-white text-sm sm:text-base md:text-lg font-medium">
                          {t('hero.maryOverlay')}
                        </p>
                      </div>
                    </div>
                  </div>
                </CarouselItem>
                <CarouselItem>
                  <div className="w-full rounded-2xl shadow-2xl overflow-hidden relative">
                    <img src="/lovable-uploads/0ad5def0-05ae-47b2-9bf1-b6337db6fd87.png" alt="Woman smiling while working on computer" className="w-full h-auto" style={{
                    transform: "perspective(1000px) rotateY(-5deg) rotateX(5deg)"
                  }} />
                    <div className="absolute bottom-6 left-6 right-6">
                      <div className="bg-black/70 backdrop-blur-sm rounded-xl p-3 sm:p-4 shadow-lg border border-white/10">
                        <p className="text-white text-sm sm:text-base md:text-lg font-medium">
                          {t('hero.wairimuOverlay')}
                        </p>
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              </CarouselContent>
            </Carousel>
          </div>
        </div>
      </div>
    </div>;
};
